module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-ties-remnants.9eb8290f.png";